import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocRefPipe } from './pipes/doc-ref.pipe';

@NgModule({
  declarations: [DocRefPipe],
  imports: [CommonModule],
  exports: [DocRefPipe],
})
export class SharedModule {}
